export const getIsLoading = (state) => state.result.loading;
export const getResultFilters = (state) => state.result.filterData;
export const getResultData = (state) => state.result.compareResultData;
export const getOrganizationList = (state) => state.result.organizationList;
export const getDynamicRangeList = (state) => state.result.dynamicRangeList;
